import { BaseEnum } from "../BaseEnum";

export class PricingTierModule extends BaseEnum {
  static DBP = 1;
  static DASHBOARD_ENTERPRISE_CRISIS = 2;
  static TAXONOMY = 3;
  static DSR = 4;
  static CASHFLOWS = 5;

  static Codes = [
    this.DBP,
    this.DASHBOARD_ENTERPRISE_CRISIS,
    this.TAXONOMY,
    this.DSR,
    this.CASHFLOWS,
  ];
  static _labelKeys = [
    "dbp",
    "DASHBOARD_ENTERPRISE_CRISIS",
    "TAXONOMY",
    "DSR",
    "CASHFLOWS",
  ];
}
